import {FILTERS_PLACEHOLDERS as sharedFiltersPlaceholders} from '../common/filtersPlaceholders.js'

// Define only the filters placeholders that are different from the common ones
export const FILTERS_PLACEHOLDERS = {...sharedFiltersPlaceholders}
